// src/AudioSpectrum/effects/fountain.js
import { getHSLColor } from '../colorUtils.js';

export const drawFountain = (ctx, frequencyData, width, height, fountainRef) => {
  ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
  ctx.fillRect(0, 0, width, height);
  
  const fountainCount = 3;
  const fountainWidth = width / fountainCount;
  
  // 각 분수에서 파티클 생성
  for (let f = 0; f < fountainCount; f++) {
    const fountainX = (f + 0.5) * fountainWidth;
    const freqStart = Math.floor((f / fountainCount) * frequencyData.length);
    const freqEnd = Math.floor(((f + 1) / fountainCount) * frequencyData.length);
    const avgValue = frequencyData.slice(freqStart, freqEnd).reduce((a, b) => a + b, 0) / (freqEnd - freqStart);
    
    if (avgValue > 50) {
      const particleCount = Math.floor(avgValue / 20);
      for (let i = 0; i < particleCount; i++) {
        fountainRef.current.push({
          x: fountainX + (Math.random() - 0.5) * 20,
          y: height - 80,
          vx: (Math.random() - 0.5) * 2,
          vy: -(avgValue / 255) * 12 - Math.random() * 4,
          life: 1.0,
          decay: 0.008,
          size: Math.random() * 2 + 1,
          color: getHSLColor(f * 120 + Math.random() * 60, 100, 70),
          gravity: 0.15,
          trail: []
        });
      }
    }
  }
  
  // 분수 파티클 업데이트
  fountainRef.current = fountainRef.current.filter(particle => {
    // 궤적 추가
    particle.trail.push({ x: particle.x, y: particle.y, life: 0.5 });
    if (particle.trail.length > 8) particle.trail.shift();
    
    particle.x += particle.vx;
    particle.y += particle.vy;
    particle.vy += particle.gravity;
    particle.life -= particle.decay;
    
    if (particle.life > 0 && particle.y < height + 50) {
      // 궤적 그리기
      particle.trail.forEach((point, index) => {
        point.life -= 0.06;
        if (point.life > 0) {
          ctx.globalAlpha = point.life * 0.7;
          ctx.fillStyle = particle.color;
          const size = particle.size * (index / particle.trail.length);
          ctx.beginPath();
          ctx.arc(point.x, point.y, size, 0, Math.PI * 2);
          ctx.fill();
        }
      });
      
      // 메인 파티클
      ctx.globalAlpha = particle.life;
      ctx.fillStyle = particle.color;
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      ctx.fill();
      
      // 물방울 효과
      if (particle.vy > 0 && Math.random() < 0.3) {
        ctx.strokeStyle = particle.color;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.ellipse(particle.x, particle.y, particle.size * 1.5, particle.size * 0.8, 0, 0, Math.PI * 2);
        ctx.stroke();
      }
      
      ctx.globalAlpha = 1.0;
      return true;
    }
    return false;
  });
};